import React, { Component } from 'react';
import Header from './Header';
import Detallado from './Detallado';
import Footer from './Footer';
import Intro from './questions/Intro';
import Step1 from './questions/Step1';
import Step2 from './questions/Step2';
import Step3 from './questions/Step3';
import Step4 from './questions/Step4';
import Step5 from './questions/Step5';
import Step6 from './questions/Step6';
import Step7 from './questions/Step7';
import Step8 from './questions/Step8';
import Step9 from './questions/Step9';
import Step10 from './questions/Step10';
import Step11 from './questions/Step11';
import Step12 from './questions/Step12';

import Apoyo from './circles/Apoyo';
import Felicidad from './circles/Felicidad';
import Identidad from './circles/Identidad';
import Trabajo from './circles/Trabajo';
import Oportunidad from './circles/Oportunidad';
import Equipo from './circles/Equipo';

const styleP = {
  textAlign: 'left',
  fontSize: '16px'
};

const styleOL = {
  textAlign: 'left',
  fontSize: '16px',
  listStyle: 'decimal'
};

export default class Survey extends Component {
  state = {
    open: false,
    openDetallado: false,
    preg1: 0,
    preg2: 0,
    preg3: 0,
    preg4: 0,
    preg5: 0,
    preg6: 0,
    preg7: 0,
    preg8: 0,
    preg9: 0,
    preg10: 0,
    preg11: 0,
    preg12: 0,
    preg13: 0,
    preg14: 0,
    preg15: 0,
    preg16: 0,
    preg17: 0,
    preg18: 0,
    preg19: 0,
    preg20: 0,
    preg21: 0,
    preg22: 0,
    preg23: 0,
    preg24: 0,
    preg25: 0,
    preg26: 0,
    preg27: 0,
    preg28: 0,
    preg29: 0,
    preg30: 0,
    preg31: 0,
    preg32: 0,
    preg33: 0,
    preg34: 0,
    preg35: 0,
    preg36: 0,
    preg37: 0,
    preg38: 0,
    preg39: 0,
    preg40: 0,
    preg41: 0,
    preg42: 0,
    preg43: 0,
    preg44: 0,
    preg45: 0,
    preg46: 0,
    preg47: 0,
    apoyoGerencial: 0,
    felicidadPersonal: 0,
    identidadPertenencia: 0,
    trabajoRecursos: 0,
    oportunidades: 0,
    trabajoEquipo: 0,
    preguntas: []
  };

  componentDidMount() {
    var addScript = document.createElement('script');
    addScript.setAttribute('src', '/js/functions.js');
    document.body.appendChild(addScript);
    window.init();
  }

  handleSubmit = async e => {
    e.preventDefault();
    if (
      document
        .getElementById('complete')
        .getAttribute('style')
        .includes('block')
    ) {
      await this.setPreg();

      // Apoyo Gerencial
      for (let i = 1; i <= 8; i++) {
        let item = 'preg' + i;
        this.setState({
          apoyoGerencial:
            this.state.apoyoGerencial + parseInt(this.state[item], 10)
        });
      }

      // Felicidad Personal
      for (let i = 9; i <= 12; i++) {
        let item = 'preg' + i;
        this.setState({
          felicidadPersonal:
            this.state.felicidadPersonal + parseInt(this.state[item], 10)
        });
      }

      // Identidad y Pertenencia
      for (let i = 13; i <= 22; i++) {
        let item = 'preg' + i;
        this.setState({
          identidadPertenencia:
            this.state.identidadPertenencia + parseInt(this.state[item], 10)
        });
      }

      // Lugar de Trabajo y Recursos
      for (let i = 23; i <= 26; i++) {
        let item = 'preg' + i;
        this.setState({
          trabajoRecursos:
            this.state.trabajoRecursos + parseInt(this.state[item], 10)
        });
      }

      // Oportunidades para el Crecimiento
      for (let i = 27; i <= 32; i++) {
        let item = 'preg' + i;
        this.setState({
          oportunidades:
            this.state.oportunidades + parseInt(this.state[item], 10)
        });
      }

      // Lugar de Trabajo y Recursos
      for (let i = 33; i <= 39; i++) {
        let item = 'preg' + i;
        this.setState({
          trabajoRecursos:
            this.state.trabajoRecursos + parseInt(this.state[item], 10)
        });
      }

      // Trabajo en Equipo
      for (let i = 40; i <= 47; i++) {
        let item = 'preg' + i;
        this.setState({
          trabajoEquipo:
            this.state.trabajoEquipo + parseInt(this.state[item], 10)
        });
      }

      this.setState({ open: true }, () => {
        let preg1 = document.getElementById('topLoader');
        while (preg1.childNodes.length > 1) {
          preg1.removeChild(preg1.firstChild);
        }
        let preg3 = document.getElementById('equipo');
        while (preg3.childNodes.length > 1) {
          preg3.removeChild(preg3.firstChild);
        }
        let preg4 = document.getElementById('felicidad');
        while (preg4.childNodes.length > 1) {
          preg4.removeChild(preg4.firstChild);
        }
        let preg5 = document.getElementById('identidad');
        while (preg5.childNodes.length > 1) {
          preg5.removeChild(preg5.firstChild);
        }
        let preg6 = document.getElementById('oportunidad');
        while (preg6.childNodes.length > 1) {
          preg6.removeChild(preg6.firstChild);
        }
        let preg7 = document.getElementById('trabajo');
        while (preg7.childNodes.length > 1) {
          preg7.removeChild(preg7.firstChild);
        }
      });
    }
  };

  setPreg = () => {
    return new Promise((resolve, reject) => {
      let pregValues = {};
      for (let x = 1; x <= 47; x++) {
        document.querySelectorAll(`#preg${x} li`).forEach((e, i) => {
          if (e.firstChild.classList[1] === 'checked') {
            let item = 'preg' + x;
            pregValues[item] = { [item]: item, valor: e.lastChild.textContent };
            this.setState({
              [item]: parseInt(e.firstChild.firstChild.value, 10)
            });
          }
        });
      }
      this.setState({ preguntas: pregValues });
      resolve();
    });
  };

  handleDetallado = () => {
    this.setState({ openDetallado: !this.state.openDetallado });
  };

  render() {
    return (
      <React.Fragment>
        <Header />

        <div className="container">
          <div className="row">
            <div className="col-md-12 main-title">
              <h1>Felicidad laboral</h1>
            </div>
          </div>
        </div>
        <section className="container" id="main">
          <div id="survey_container">
            <div id="top-wizard">
              <strong>
                Progreso
                <span id="location" />
              </strong>
              <div id="progressbar" />
              <div className="shadow" />
            </div>

            <form name="example-1" id="wrapped">
              <div id="middle-wizard">
                <Intro />
                <Step1 />
                <Step2 />
                <Step3 />
                <Step4 />
                <Step5 />
                <Step6 />
                <Step7 />
                <Step8 />
                <Step9 />
                <Step10 />
                <Step11 />
                <Step12 />
                <div className="submit step" id="complete">
                  <h3>
                    ¡Gracias por completar tu encuesta y por tu interés en
                    conocer qué tan feliz eres en el trabajo!
                  </h3>
                  <p style={{ ...styleP }}>
                    <strong>
                      Hemos recopilado tus resultados en 6 dimensiones:
                    </strong>
                  </p>
                  <p style={{ ...styleP }}>
                    <strong>Apoyo Gerencial:</strong> evalúa la relación que
                    tienes con tu supervisor inmediato, su capacidad de
                    comunicar la visión, la cultura de reconocimiento que
                    existe, y los niveles de autonomía, así como de
                    involucramiento al equipo (y a ti) en la toma de decisiones.
                    El supervisor juega un rol importante en la felicidad
                    laboral de los equipos.
                  </p>
                  <p style={{ ...styleP }}>
                    <strong>Felicidad Personal:</strong> en esta dimensión se
                    evalúa tu felicidad personal, tu salud y energía. Es vital,
                    para una felicidad laboral.
                  </p>
                  <p style={{ ...styleP }}>
                    <strong>Identidad y Pertenencia:</strong> En esta dimensión
                    evaluamos el orgullo que sientes de ser parte de la empresa
                    para la que laboras. Tiene que ver con la importancia que
                    para ti tiene tu trabajo y la contribución que haces para el
                    mundo. Analiza tu nivel de entusiasmo y pasión por tu
                    trabajo.
                  </p>
                  <p style={{ ...styleP }}>
                    <strong>Lugar de Trabajo y Recursos:</strong> en esta
                    dimensión evaluamos al lugar de trabajo como sí. Tiene que
                    ver con el equilibrio entre vida y trabajo, con la
                    disposición de los recursos necesarios para trabajar, contar
                    con condiciones físicas adecuadas para hacer bien tu
                    trabajo.
                  </p>
                  <p style={{ ...styleP }}>
                    <strong>Trabajo en Equipo:</strong> en esta dimensión
                    analizamos el clima laboral y la capacidad que tiene tu
                    equipo de trabajar juntos, de apoyarse. Analiza la
                    colaboración que hay entre los compañeros de trabajo y su
                    capacidad de disfrutar haciendo lo que hacen.
                  </p>
                  <div className="row" style={{ marginTop: '50px' }}>
                    <div className="col-md-4">
                      <h4 className="title-progress">Apoyo Gerencial</h4>
                      <Apoyo value={this.state.apoyoGerencial} />
                    </div>
                    <div className="col-md-4">
                      <h4 className="title-progress">Felicidad Personal</h4>
                      <Felicidad value={this.state.felicidadPersonal} />
                    </div>
                    <div className="col-md-4">
                      <h4 className="title-progress">
                        Identidad y Pertenencia
                      </h4>
                      <Identidad value={this.state.identidadPertenencia} />
                    </div>
                  </div>
                  <div className="row">
                    <br />
                    <div className="col-md-4">
                      <h4 className="title-progress">
                        Lugar de Trabajo y Recursos
                      </h4>
                      <Trabajo value={this.state.trabajoRecursos} />
                    </div>
                    <div className="col-md-4">
                      <h4 className="title-progress">
                        Oportunidades para el Crecimiento
                      </h4>
                      <Oportunidad value={this.state.oportunidades} />
                    </div>
                    <div className="col-md-4">
                      <h4 className="title-progress">Trabajo en Equipo</h4>
                      <Equipo value={this.state.trabajoEquipo} />
                    </div>
                  </div>
                  <h3 style={{ marginTop: '50px' }}>
                    ¿Qué hacer con estos resultados?
                  </h3>
                  <ol style={{ ...styleOL }}>
                    <li style={{ marginBottom: '10px' }}>
                      Identifica tus fortalezas y oportunidades como integrante
                      de tu equipo de trabajo. Analiza a nivel personal, dónde
                      te ubicas y qué hace falta para llegar a lograr la
                      felicidad que quieres.
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                      Identifica las fortalezas de tu equipo de trabajo.
                      Reflexiona donde están bien y oportunidades como equipo
                      tienen, para estar en un lugar mejor, a nivel de clima
                      laboral, motivación, comunicación…. En fin, para ser más
                      felices como equipo de trabajo.
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                      Ahora, pasa a un nivel más macro y analiza a tu empresa.
                      Mira estas dimensiones y analiza como estos resultados
                      pudieran ser un reflejo de los resultados de tu empresa.
                      ¿Dónde tu empresa está fuerte y dónde necesita trabajar?
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                      Ahora es momento de compartir estos hallazgos, reflexiones
                      y recomendaciones con tu Gerente o Supervisor Directo.
                      Reúne a tu equipo de trabajo y juntos creen un plan de
                      acción para elevar sus estándares y ser más felices en el
                      trabajo.
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                      ¡Llámanos!... Es nuestra pasión acompañarte a crear una
                      cultura ganadora para toda tu empresa y diseñar espacios
                      de trabajo enfokados y felices.{' '}
                      <strong>809-331-3737</strong> al 37 o escríbenos a{' '}
                      <strong>info@fokoconsulting.com</strong>
                    </li>
                  </ol>
                  <a
                    href="https://www.fokoconsulting.com"
                    className="btn-foko"
                    target="_blank"
                  >
                    Foko Consulting
                  </a>
                  <Detallado valores={this.state.preguntas} />
                </div>
              </div>

              {!this.state.open && (
                <div id="bottom-wizard">
                  <button type="button" name="backward" className="backward">
                    Volver
                  </button>
                  <button
                    type="submit"
                    name="forward"
                    onClick={this.handleSubmit}
                    className="forward"
                  >
                    Siguiente{' '}
                  </button>
                </div>
              )}
            </form>
          </div>
        </section>

        <Footer />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/survey/Survey.jsx